/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Badge,
	Table,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";
import Icon from "../components/Icon";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomerSidebar from "../components/CustomerSidebar";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import { ordersUrl } from "../global/url";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
} from "../global/browserFunctions";

class CustomerOrders extends Component {
	constructor(props) {
		super(props);
		document.title = "My Orders";
		var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
		this.state = {
			ordersFull: [],
			ordersPaginated: [],
			hasOrders: false,
			loadingText: "Loading....",
			currentPage: pageNum - 1,
		};
		this.PAGE_SIZE = 5;
		this.handleClick = this.handleClick.bind(this);

		if (!getCookie("log")) {
			this.GoToPage("/");
		}
	}

	GoToPage(path) {
		this.props.history.push(path);
	}

	componentDidMount() {
		this.fetchOrders();
	}
	handleClick(e, index) {
		//Function that triggers pagination
		e.preventDefault();
		if (index >= 0 && index <= this.state.ordersFull.length - 1) {
			this.setState({ currentPage: index });
			this.setState({ ordersPaginated: this.state.ordersFull[index] });
			window.scrollTo(0, 0);
			var query = "?page=" + ++index;

			this.props.history.push({
				pathname: "/orders",
				search: query,
			});
		}
	}
	fetchOrders() {
		var self = this;
		this.setState({ loading: true });
		var query = "&apiType=listOrders&customerId=";
		var customer = getCookie("customid");
		query += customer;
		jquery
			.ajax({
				url: ordersUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary.status == "SUCCESS") {
						var orders = (data.data && data.data.orders) || [];
						if (orders.length > 0) {
							//self.setState({ ordersPaginated: orders });
							self.setPagedData(orders);
							self.setState({ hasOrders: true });
						} else {
							self.setState({ loadingText: "No orders found" });
							self.setState({ hasOrders: false });
						}
					} else {
						if (data.summary.reason == "NO_RECORD_FOUND") {
							self.setState({ loadingText: "No orders found" });
							self.setState({ hasOrders: false });
							showNotification(
								"",
								"info",
								"No orders found for your customer"
							);
						}
						else {
							self.setState({ loadingText: "No orders found" });
							self.setState({ hasOrders: false });
							showNotification(
								"Sorry",
								"danger",
								"An unknown error occurred. Couldn't fetch your orders"
							);
						}
					}
				} catch (error) {
					self.setState({ loadingText: "No orders found" });
					self.setState({ hasOrders: false });
					console.log("error@address", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch your orders"
					);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				self.setState({ loadingText: "No orders found" });
				self.setState({ hasOrders: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Check your network"
				);
			});
	}

	setPagedData(orders) {
		var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1; //Get page number from url param else 1
		var ordersPaginated = [];

		var pagedData =
			Array.isArray(orders) && orders.length
				? this.chunkArray(orders, this.PAGE_SIZE) //Set 5 orders per page
				: [];
		//console.log('pagedData',pagedData)
		this.setState({ ordersFull: pagedData });
		ordersPaginated = pagedData[pageNum - 1] || [];
		this.setState({ ordersPaginated: ordersPaginated });
	}

	chunkArray(array, size) {
		//Chunk array for pagination
		const chunked_arr = [];
		let copied = [...array]; // ES6 destructuring
		const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
		for (let i = 0; i < numOfChild; i++) {
			chunked_arr.push(copied.splice(0, size));
		}

		return chunked_arr;
	}
	render() {
		return (
			<React.Fragment>
				<Header headermenu={this.headermenu} history={this.props.history} />
				<Loader loading={this.state.loading} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>Orders</BreadcrumbItem>
						</Breadcrumb>
						<div className='hero-content'>
							<h1 className='hero-heading'>Your orders</h1>
						</div>
					</Container>
				</section>
				<section className='pb-6'>
					<Container>
						<Row>
							<Col xl='3' lg='4' className='mb-5'>
								<CustomerSidebar history={this.props.history} />
							</Col>
							<Col lg='8' xl='9'>
								{!this.state.hasOrders && <div>{this.state.loadingText}</div>}

								{this.state.hasOrders && (
									<React.Fragment>
										<Table hover className='table-responsive-md'>
											<thead className='bg-light'>
												<tr>
													<th className='py-4 pl-4 text-sm border-0'>
														Order #
													</th>
													<th className='py-4 text-sm border-0'>Date</th>
													<th className='py-4 text-sm border-0'>Total</th>
													<th className='py-4 text-sm border-0'>Action</th>
												</tr>
											</thead>
											<tbody>
												{this.state.ordersPaginated.map((order, index) => (
													<tr key={index}>
														<th className='pl-4 py-5 align-middle'>
															{order.tranid.value}
														</th>
														<td className='py-5 align-middle'>
															{order.trandate.value}
														</td>
														<td className='py-5 align-middle'>
															${order.total_fx.value ? Number(order.total_fx.value).toFixed(2) : order.total_fx.value}
														</td>
														<td className='py-5 align-middle'>
															<a
																href={
																	`/order-deatils?id=` + order.internalid.value
																}
															>
																<Button color='outline-dark' size='sm'>
																	View
																</Button>
															</a>
														</td>
													</tr>
												))}
											</tbody>
										</Table>
										<div className='pagination-wrapper'>
											<Pagination className='d-flex justify-content-center mb-5 mt-3'>
												<PaginationItem
													className='page-arrow'
													disabled={this.state.currentPage <= 0}
													onClick={(e) =>
														this.handleClick(e, this.state.currentPage - 1)
													}
												>
													<span className='page-arrow' >
														<span aria-hidden='true'>
															<Icon icon='angle-left-1' className='page-icon' />
														</span>

														<PaginationLink
															className='sr-only'
															onClick={(e) =>
																this.handleClick(e, this.state.currentPage - 1)
															}
															previous
															href='#'
														/>
														<span className='sr-only'>Previous</span>
													</span>
												</PaginationItem>

												{this.state.ordersFull.map((page, i) => (
													<PaginationItem
														active={i === this.state.currentPage}
														key={i}
													>
														<PaginationLink
															onClick={(e) => this.handleClick(e, i)}
															href='#'
														>
															{i + 1}
														</PaginationLink>
													</PaginationItem>
												))}

												<PaginationItem
													className='page-arrow'
													disabled={
														this.state.currentPage >=
														this.state.ordersFull.length - 1
													}
													onClick={(e) =>
														this.handleClick(e, this.state.currentPage + 1)
													}
												>
													<span className='page-arrow' >
														<span aria-hidden='true'>
															<Icon
																icon='angle-right-1'
																className='page-icon'
															/>
														</span>
														<PaginationLink
															className='sr-only'
															onClick={(e) =>
																this.handleClick(e, this.state.currentPage + 1)
															}
															next
															href='#'
														/>
														<span className='sr-only'>Next</span>
													</span>
												</PaginationItem>
											</Pagination>
										</div>
									</React.Fragment>
								)}
							</Col>
						</Row>
					</Container>
				</section>
				<Footer />
			</React.Fragment>
		);
	}
}

export default CustomerOrders;
